module.exports = __webpack_public_path__ + "static/img/far2_active.79e747f5.png";